var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "c-input-label" }, [
        _vm._v("Пол "),
        _vm.field.required
          ? _c("span", { staticClass: "c-input-label__required" }, [
              _vm._v("*"),
            ])
          : _vm._e(),
      ]),
      _c("c-switcher", {
        staticClass: "h-switcher",
        attrs: {
          type: "group",
          items: [
            { icon: "male", value: 1, tooltip: "Мужской" },
            { icon: "female", value: 2, tooltip: "Женский" },
          ],
        },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
      _vm.error
        ? _c("error-feedback", { attrs: { text: _vm.error } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }